var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Proposals',{attrs:{"product-id":_vm.productID,"statuses":_vm.statuses,"steps":new Set([
    'upload',
    'basic',
    'documents',
    'address',
    'bank',
    'proposal-data',
  ]),"title":_vm.meta.title}},[(!_vm.loading && _vm.modal.creditor)?_c('ModalCreditor',{on:{"close":function($event){return _vm.close({ key: 'creditor' })}}}):_vm._e(),(!_vm.loading && _vm.modal.survey)?_c('ModalSurveyAccordance',{on:{"close":function($event){return _vm.close({ key: 'survey' })}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }